export * from 'server/models/CoordinationCardDetailsResponse';


// WEBPACK FOOTER //
// ./data/models/CoordinationCardDetailsResponse.ts